import styled from "styled-components";
import { themevals as theme } from "theme/themevals";

export const BackButton = styled.div`
    display:flex;
    align-items:center;
    justify-content:center;
    margin-top:30px;
    margin-bottom:0px;
    span{
        color:${theme.colors.body};
        font-weight:500;
        font-size:14px;
    }
    a{
        display:flex;
        text-decoration:none;
        align-items:center;
        &:hover{
            text-decoration:none;
            color:${theme.colors.black} !important;
        }
    }
`

export const ForgotPasswordLink = styled.div`
    margin-top:30px;
    margin-bottom:0px;
    text-align:center;
    a{
        text-decoration:none;
        color:${theme?.colors?.black};
        font-size:14px;
        font-weight:500;
         &:hover{
            text-decoration:none;
            color:${theme.colors.black} !important;
        }
    }
`

export const SuccessIconWrap = styled.div`
    width:50px;
    height:50px;
    display:flex;
    align-items:center;
    justify-content:center;
    background:#F8F8F8;
    border-radius:6px;
    margin:auto auto 20px auto;
`